exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.body[data-v-5ea6e0ba] {\n  padding-bottom: 5rem;\n}\n.abc[data-v-5ea6e0ba] {\n  width: 100%;\n  height: 2rem;\n  background-color: #88aabb;\n}\n", "", {"version":3,"sources":["/Users/zhangpuxi/ZhangPuXi/Workspace/WebGaotieVue/src/projects/virusTrip/pages/searchResult/index.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;CACtB;AACD;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;CAC3B","file":"index.vue","sourcesContent":["\n.body[data-v-5ea6e0ba] {\n  padding-bottom: 5rem;\n}\n.abc[data-v-5ea6e0ba] {\n  width: 100%;\n  height: 2rem;\n  background-color: #88aabb;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ea6e0ba","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/projects/virusTrip/pages/searchResult/index.vue
// module id = GBL5
// module chunks = 1